module.exports = __webpack_public_path__ + "img/professions-man-construction-1.d15f16e3.svg";